import styled from 'styled-components';
import { theme } from '../../../../../global';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 40px;

  button {
    height: 56px;
  }
`;

export const InputsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  input {
    font-weight: 500;
    color: ${theme.colors.font_dark};
    &:focus {
      border: 1px solid rgba(83, 85, 95, 1);
    }
  }
`;
